/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Geometry } from './Geometry';
import { ObjectSelector } from '../../ObjectSelector';
import { Vector3, Line } from 'three';
export const createLine = (from, to, material) => {
    const line = new Line(Geometry.createLine(from, to), material);
    line.computeLineDistances();
    line.userData[ObjectSelector.IMAGINARY] = true;
    return line;
};
export const createLineTo = (to, material) => createLine(new Vector3(), to, material);
//# sourceMappingURL=createLine.js.map